export default {"src":"/_next/static/media/user-quote-purple.fe4d48e6.svg","height":46,"width":74,"blurWidth":0,"blurHeight":0};